<div  class="MainContainer">
  <div class="MainTitleBar">
    <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'DashMenu.DocumentsMenu.Receptions' | translate }}</p>
    <div class="SectionHalfTitle SectionHalfTitleRight">
        <button (click)="InitializeEFacturaStepOne();" style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">downloading</i> {{'ImportFromEFactura' | translate}}</button>
        <button style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary" (click)="this.parent.RedirectToURL('dashboard/purchases/reception');"><i class="material-icons">add</i> {{'NewReception' | translate}}</button>
        <button (click)="ExportAllOrPageOnlyQuestion = true;" style="padding-left: 10px;background:#32aa3a;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}}</button>
        <button (click)="GenerateSAGAReceptionExport();" style="padding-left: 10px;background:#32aa3a;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}} SAGA</button>
      </div>
</div>

<div class="overlay" *ngIf="ShowStockEntryDateTodayQuestion || ShowFinalCheckImportEFactura || EFacturaStepTwo || EFacturaStepOne || ShowForceStatusContainer || ShowReceivedStatusConfirmation || ShowMustSelectSinglePartnerError || ShowExportBulkQuestion || ShowDeleteShippingDetailsContainer || ExportAllOrPageOnlyQuestion || ShowShippingDetailsContainer || ShowDeleteBoxQuestion || ShowAutoPrintBulkQuestion || ShowDeleteReceptionRelatedPayments || ShowReactivateDocumentQuestion || ShowDeactivateDocumentQuestion || ShowDeleteReceptionQuestion || ShowPushConnectedServiceResults || ShowConnectedServiceContainer || ShowOriginalCurrencyError || SingleCurrencyOnCollectivePaymentError || ShowDeactivatedDocumentsOnSelectAllQuestion || showEditPartnerPopUp || showReceptionVisualizer || ShowSuggestionPaymentsContainer || ShowPaymentContainer;" (click)="showEditPartnerPopUp = false; showReceptionVisualizer = false;"></div>

<div class="EFacturaStepOne animated fadeInDown" *ngIf="this.EFacturaStepOne == true;">
  <!-- <div class="EFacturaStepBack">
      <i class="material-icons">arrow_back_ios_new</i>
  </div> -->
  <div class="EFacturaStepClose" (click)="this.EFacturaStepOne = false;">
      <i class="material-icons">close</i>
  </div>
  <div class="EFacturaStepTitle">
    {{'ImportFromEFactura' | translate}}
  </div>
  <div class="EFacturaStepBody">
    <div class="EFacturaStepBodyTitle">
      {{'ChooseEFacturaPeriod' | translate}}
    </div>
  
    <div class="EFacturaStepOneRow">
      <mat-form-field appearance="outline" class="ReceptionProductsColDropDown" style="width: 95%;">
        <mat-label>{{ 'VATNumber' | translate }}*</mat-label>
        <input matInput placeholder="{{ 'VATNumber' | translate }}*" autocomplete="off" [(ngModel)]="EFacturaFilter.VATNumber">
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="EFacturaStepOneDateTimePicker">
        <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dp2" [formControl]="EFacturaFromDate"
               [min]="minDate" [max]="maxDate" [(ngModel)]="EFacturaFilter.FromDate" 
               (dateChange)="ClearPeriod()">
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="EFacturaStepOneDateTimePicker">
        <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dp3" [formControl]="EFacturaToDate"
               [min]="minDate" [max]="maxDate" [(ngModel)]="EFacturaFilter.ToDate" 
               (dateChange)="ClearPeriod()">
        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
        <mat-datepicker #dp3></mat-datepicker>
      </mat-form-field>

      <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.loadingEFacturaDocuments == true"></mat-spinner>
    </div>
 
  </div>
  <div class="EFacturaStepCommand">
      <button mat-flat-button color="primary" (click)="GetEFacturaSupplierFiles();" [disabled]="this.loadingEFacturaDocuments == true">
        {{'Next' | translate}}
        <i class="material-icons">navigate_next</i>
      </button>
  </div>
</div>

<div class="ETransportStepOneContainer animated fadeInDown" *ngIf="ShowETransportStepOne">
  <div class="ETransportStepOneTitle">
    <p>{{'GenerateUITTitle' | translate}} [{{this.UITShippingCompany?.Name}}]</p>
    <i class="material-icons" (click)="ShowETransportStepOne = false;">close</i>
  </div>
  <div class="ETransportStepOneBody">
    <div class="ETransportStepOneBodyRow">
      <div class="PopUpBodyOneThirddContainer">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'ETransportCustomsStation' | translate }}</mat-label>
           <mat-select name="ETransportCustomsStation" [compareWith]="compareFn" [(ngModel)]="ETransportCustomsStation">
            <mat-option *ngFor="let a of this.CustomsStations;" [value]="a">
               {{a.Name}}
             </mat-option>
           </mat-select>
          </mat-form-field>
        </div>
         
        <div class="PopUpBodyTwoThirdsContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportDocumentType' | translate }}</mat-label>
             <mat-select name="ETransportDocumentType" [compareWith]="compareFn" [(ngModel)]="ETransportDocumentType">
              <mat-option *ngFor="let a of this.ETransportDocumentTypes;" [value]="a">
                 {{a.Name}}
               </mat-option>
             </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="ETransportStepOneBodyRow">
      <div class="PopUpBodyOneThirddContainer">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'ETransportMeasuringUnit' | translate }}</mat-label>
           <mat-select name="ETransportMeasuringUnit" [compareWith]="compareFn" [(ngModel)]="ETransportMeasuringUnit">
            <mat-option *ngFor="let a of this.ETransportMeasuringUnits;" [value]="a">
               {{a.Name}}
             </mat-option>
           </mat-select>
          </mat-form-field>
        </div>
         
        <div class="PopUpBodyTwoThirdsContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportOperationReason' | translate }}</mat-label>
             <mat-select name="ETransportOperationReason" [compareWith]="compareFn" [(ngModel)]="ETransportOperationReason">
              <mat-option *ngFor="let a of this.ETransportOperationReasons;" [value]="a">
                 {{a.Name}}
               </mat-option>
             </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="ETransportStepOneBodyRow">
      <div class="PopUpBodyOneThirddContainer">
        <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
          <mat-label>{{ 'AutoPlatesNumber' | translate }}</mat-label>
          <input matInput placeholder="{{ 'AutoPlatesNumber' | translate }}" autocomplete="off" [(ngModel)]="UITAutoPlatesNumber">
        </mat-form-field>
      </div>
         
        <div class="PopUpBodyTwoThirdsContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportOperationType' | translate }}</mat-label>
             <mat-select name="ETransportOperationType" [compareWith]="compareFn" [(ngModel)]="ETransportOperationType">
              <mat-option *ngFor="let a of this.ETransportOperationTypes;" [value]="a">
                 [{{a.Name}}] {{a.Description}}
               </mat-option>
             </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="ETransportStepOneBodyRow">
      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: 95%;">
        <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
         <mat-select name="ETransportOperationType" [compareWith]="compareFn" [(ngModel)]="UITShippingCompany">
          <mat-option *ngFor="let s of this.ShippingCompanies;" [value]="s">
             {{s.Name}}
           </mat-option>
         </mat-select>
        </mat-form-field>
    </div>

    <div class="ETransportStepOneBodyRow" *ngIf="this.ETransportOperationType.ID == 40 || this.ETransportOperationType.ID == 50">
      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: 95%;">
        <mat-label>{{ 'ETransportCustomsBureau' | translate }}</mat-label>
         <mat-select name="ETransportCustomsBureau" [compareWith]="compareFn" [(ngModel)]="ETransportCustomsBureau">
          <mat-option *ngFor="let s of this.ETransportCustomsBureaus;" [value]="s">
             {{s.Name}}
           </mat-option>
         </mat-select>
        </mat-form-field>
    </div>
    
  </div>
  <div class="ETransportStepOneCommands">
    <button mat-raised-button color="accent" class="FilterButtonAction" (click)="UploadETransportInvoice(this.CurrentReception);">{{ 'GenerateUIT' | translate }}</button>
  </div>
</div>

<div class="EFacturaStepTwo animated fadeInDown" *ngIf="this.EFacturaStepTwo == true;">
  <div class="EFacturaStepClose" (click)="this.EFacturaStepTwo = false;">
      <i class="material-icons">close</i>
  </div>
  <div class="EFacturaStepTitle">
    {{'ImportFromEFactura' | translate}}
  </div>
  <div class="EFacturaStepBody">
    <div class="EFacturaDocumentTableRow EFacturaDocumentTableRowHeadder">
      <div class="EFacturaDocumentTableCol" style="width: 5%;">
        <mat-checkbox class="tableColCheckBox" [(ngModel)]="EFacturaAllSelected" (change)="SelectAllEFactura();"></mat-checkbox>
      </div>
      <div class="EFacturaDocumentTableCol" style="width: 5%;">
        <p>#</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 10%;">
        <p>{{'Type' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 15%;">
        <p>{{'Date' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 15%; text-align: left;">
        <p>{{'CompanyName' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 10%; text-align: left;">
        <p>{{'Partners.VAT' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 10%;">
        <p>{{'Document' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 5%;">
        <p>{{'TaxPayer' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 5%;">
        <p>{{'Total' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 5%;">
        <p>{{'Currency' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 5%;">
        <p>{{'Status' | translate}}</p>
      </div>

      <div class="EFacturaDocumentTableCol" style="width: 10%;">
        <p>{{'Actions' | translate}}</p>
      </div>
    </div>

    <div class="blurrOverlay" *ngIf="this.parent.loading == true;"></div>

    <div [ngClass]="{'blurr': this.parent.loading == true}">
      <div class="EFacturaDocumentTableRow" *ngFor="let row of this.EFacturaSupplierFiles; let i=index;">
        <div class="EFacturaDocumentTableCol" style="width: 5%;">
          <mat-checkbox class="tableColCheckBox" [(ngModel)]="row.IsSelected" (change)="CheckIfAnyCheckedEFactura();"></mat-checkbox>
        </div>
        <div class="EFacturaDocumentTableCol" style="width: 5%;">
          <p>{{i + 1}}</p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 10%;">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{ 'EFacturaSupplierFileRowType' | translate }}</mat-label>
            <mat-select name="EFacturaSupplierFileRowType" [compareWith]="compareFn" [(ngModel)]="row.Type">
              <mat-option *ngFor="let t of this.EFacturaSupplierFileRowTypes" [value]="t">
                {{t.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 15%;">
          <p>{{row.EventRegisterUI}}</p>
          <p class="DupplicateRowP" *ngFor="let r of row.Files?.Reception?.DupplicateReceptions; let j=index;">
            {{r.EntryDate}}
          </p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 15%; text-align: left;">
          <p>{{row.Partner}}</p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 10%; text-align: left;">
          <p>{{row.VATNumber}}</p>
          <p class="DupplicateRowP" *ngFor="let r of row.Files?.Reception?.DupplicateReceptions; let j=index;">
            {{r.Reception}}
          </p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 10%;">
          <p>{{row.DocumentNumber}}</p>
          <p class="DupplicateRowP" *ngFor="let r of row.Files?.Reception?.DupplicateReceptions; let j=index;">
            {{r.Document}}
          </p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 5%;">
         <p>
          <span *ngIf="row.TaxPayer == true;">{{'Yes' | translate}}</span>
          <span *ngIf="row.TaxPayer != true;">{{'No' | translate}}</span>
         </p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 5%;">
          <p>{{row.Price}}</p>
          <p class="DupplicateRowP" *ngFor="let r of row.Files?.Reception?.DupplicateReceptions; let j=index;">
            {{r.Total}}
          </p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 5%;">
          <p>{{row.Currency}}</p>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 5%;">
  
          <div *ngIf="row.Type?.ID == -1;">
            <div class="StatusDot" [ngClass]="{'NeedsManualImport': row?.Files?.Reception?.DocumentImportStatus?.ID == -1, 'AllProductsFound': row?.Files?.Reception?.DocumentImportStatus?.ID == 1, 'AddedProducts': row?.Files?.Reception?.DocumentImportStatus?.ID == 0, 'DupplicateReception': row?.Files?.Reception?.DocumentImportStatus?.ID == 2 }" *ngIf="row?.Files?.Reception?.DocumentImportStatus != null;" matTooltip="{{row?.Files?.Reception?.DocumentImportStatus?.Name}}" matTooltipClass='neutral-tool-tip'></div>
          </div>
          <div *ngIf="row.Type?.ID == 1;">
            <div class="StatusDot" [ngClass]="{'NeedsManualImport': row?.Files?.Spending?.DocumentImportStatus?.ID == -1, 'AllProductsFound': row?.Files?.Spending?.DocumentImportStatus?.ID == 1, 'AddedProducts': row?.Files?.Spending?.DocumentImportStatus?.ID == 0, 'DupplicateReception': row?.Files?.Spending?.DocumentImportStatus?.ID == 2 }" *ngIf="row?.Files?.Spending?.DocumentImportStatus != null;" matTooltip="{{row?.Files?.Spending?.DocumentImportStatus?.Name}}" matTooltipClass='neutral-tool-tip'></div>
          </div>
  
          <i class="material-icons" [ngClass]="{'EditNeedsManualImport': row?.Files?.Reception?.DocumentImportStatus?.ID == -1, 'EditAllProductsFound': row?.Files?.Reception?.DocumentImportStatus?.ID == 1, 'EditAddedProducts': row?.Files?.Reception?.DocumentImportStatus?.ID == 0, 'DupplicateReception': row?.Files?.Reception?.DocumentImportStatus?.ID == 2 }" *ngIf="row?.Files?.Reception != null;" (click)="EditPreImportedReception(row?.Files?.Reception);">edit</i>
        </div>
  
        <div class="EFacturaDocumentTableCol" style="width: 10%;">
          <i class="material-icons" style="color: #0082e6;" (click)="this.PrintEFacturaFiles();" matTooltip="{{ 'PrintFiles' | translate }}" matTooltipClass='neutral-tool-tip'>local_print_shop</i>
          <i class="material-icons" style="color: #f60;" (click)="PrepareEFacturaReceptionImports(this.EFacturaSupplierFiles, row);" matTooltip="{{ 'EFacturaReceptionImportDescription' | translate }}" matTooltipClass='neutral-tool-tip'>file_download</i>
          <i class="material-icons" style="color: #32aa3a;" (click)="this.ExportEFacturaFiles();" matTooltip="{{ 'ExportFiles' | translate }}" matTooltipClass='neutral-tool-tip'>file_copy</i>
        </div>
      </div>
    </div>
  </div>
  <div class="EFacturaStepCommand">
    <button mat-raised-button color="primary" [disabled]="isEFacturaImportButtonDisabled()" (click)="FinalCheckImportEFactura();">
      <i class="material-icons">download</i>
      <span>{{'ImportFromEFactura' | translate}}</span>
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowFinalCheckImportEFactura">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowFinalCheckImportEFactura = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'FinalCheckImportEFactura' | translate }}
  </div>

  <div class="InfoQuestionBody">
    {{ 'FinalCheckImportEFacturaDesc' | translate }}
  </div>
  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowFinalCheckImportEFactura = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" style="background: #0082e6;" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowFinalCheckImportEFactura = false; ImportEFacturaFiles();">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowForceStatusContainer">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowForceStatusContainer = false; CurrentReception = null;">close</i>
  </div>
  <div class="InfoQuestionTitle" *ngIf="this.CurrentReception.Details.ForceDocumentClosing != true;">
    {{ 'ForceDocumentClosing' | translate }}
  </div>
  <div class="InfoQuestionBody" *ngIf="this.CurrentReception.Details.ForceDocumentClosing != true;">
    {{ 'ForceDocumentClosingDesc' | translate }}
  </div>

  <div class="InfoQuestionTitle" *ngIf="this.CurrentReception.Details.ForceDocumentClosing == true;">
    {{ 'DeForceDocumentClosing' | translate }}
  </div>
  <div class="InfoQuestionBody" *ngIf="this.CurrentReception.Details.ForceDocumentClosing == true;">
    {{ 'DeForceDocumentClosingDesc' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowForceStatusContainer = false; CurrentReception = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" style="background: #0082e6;" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowForceStatusContainer = false;ForceDocumentClosing(CurrentReception);">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowReceivedStatusConfirmation">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowReceivedStatusConfirmation = false; RevertReceptions();">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ApprovalStatusConfirmationTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ApprovalStatusConfirmationDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowReceivedStatusConfirmation = false; RevertReceptions();">{{ 'No' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowReceivedStatusConfirmation = false; UpdateReceptionsReceivedStatuses();">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowMustSelectSinglePartnerError">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowMustSelectSinglePartnerError = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
   {{'ShowMustSelectSinglePartnerError' | translate}}
  </div>
  <div class="InfoQuestionBody">
    {{'ShowMustSelectSinglePartnerErrorDesc' | translate}}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" (click)="ShowMustSelectSinglePartnerError = false;">
      {{ 'OK' | translate }}
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowExportBulkQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowExportBulkQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'AutoExportDocsBulkTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'AutoExportDocsBulkDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowExportBulkQuestion = false;">{{ 'No' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowExportBulkQuestion = false; AutoExportReceptions();">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteShippingDetailsContainer">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteShippingDetailsContainer = false; CurrentInvoice = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'DeleteShippingDetails' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteShippingDetailsContainer = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteShippingDetailsContainer = false;DeleteShippingDetails(this.CurrentReception.Details.ShippingDetails);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ExportAllOrPageOnlyQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ExportAllOrPageOnlyQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ExportAllOrPageOnlyQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ExportAllOrPageOnlyQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="ExportAllOrPageOnlyQuestion = false;ExportReceptionsValues();">
      <i class="material-icons">download</i>
      {{ 'ExportPage' | translate }}
    </button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ExportAllOrPageOnlyQuestion = false;ExportReceptionsValues(true);">
      <i class="material-icons">download</i>
      {{ 'ExportAllPages' | translate }}
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.DeleteQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false;DeleteBox(CurrentBox.UIID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="ShippingDetailsContainer animated fadeInDown" *ngIf="ShowShippingDetailsContainer == true;">
  <div class="ShippingDetailsContainerCloseIcon">
    <i class="material-icons" (click)="ShowShippingDetailsContainer = false;">close</i>
  </div>

  <div class="ShippingDetailsContainerTitle">{{'ShippingDetails' | translate}}</div>

  <div class="ShippingDetailsContainerBody">

    <!-- Unassociated Shipping Details Search -->
    <div style="width: 100%; margin-bottom: 15px; position: relative;">
      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-label>{{ 'SearchUnassociatedShippingLabels' | translate }}</mat-label>
        <input matInput
               type="text"
               [(ngModel)]="UnassociatedSearchTerm"
               (click)="GetUnassociatedShippingDetails()"
               placeholder="Search for existing shipping labels...">
        <mat-icon *ngIf="!ShowUnassociatedShipments && !UnassociatedShipmentsLoading" matSuffix style="color: #f60; cursor: pointer;" (click)="GetUnassociatedShippingDetails()">search</mat-icon>
        <mat-icon *ngIf="ShowUnassociatedShipments && !UnassociatedShipmentsLoading" matSuffix style="color: #f44336; cursor: pointer;" (click)="CloseUnassociatedShipments()">close</mat-icon>
        <mat-spinner *ngIf="UnassociatedShipmentsLoading" matSuffix diameter="20" style="margin-right: 10px;"></mat-spinner>
      </mat-form-field>

      <!-- Search Results Dropdown -->
      <div *ngIf="ShowUnassociatedShipments && UnassociatedShipments?.length > 0"
           style="position: absolute;
                  top: 40px;
                  left: 0;
                  width: 100%;
                  max-height: 300px;
                  overflow-y: auto;
                  overflow-x: hidden;
                  background: white;
                  border: 1px solid #ddd;
                  border-radius: 4px;
                  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                  z-index: 1000;">

        <div *ngFor="let shipment of UnassociatedShipments"
             (click)="ConnectShippingDetailsToReception(shipment)"
             style="padding: 12px 15px;
                    border-bottom: 1px solid #eee;
                    cursor: pointer;
                    transition: all 0.2s ease;"
             (mouseenter)="$event.currentTarget.style.backgroundColor='#fff3e0'; $event.currentTarget.style.transform='translateX(4px)'"
             (mouseleave)="$event.currentTarget.style.backgroundColor='white'; $event.currentTarget.style.transform='translateX(0)'">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="flex: 1;">
              <div style="font-weight: 600; color: #333; font-size: 14px; margin-bottom: 4px;">
                <i class="material-icons" style="font-size: 16px; vertical-align: middle; color: #f60; margin-right: 5px;">local_shipping</i>
                {{shipment.TrackingLabel}}
              </div>
              <div style="font-size: 12px; color: #666;">
                <span style="margin-right: 15px;">
                  <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 3px;">inventory_2</i>
                  {{shipment.Boxes?.length}} boxes
                </span>
                <span>
                  <i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 3px;">event</i>
                  {{shipment.EventRegisterUI}}
                </span>
              </div>
            </div>
            <i class="material-icons" style="color: #4CAF50; font-size: 20px;">add_circle</i>
          </div>
        </div>

        <div *ngIf="UnassociatedShipments?.length === 0"
             style="padding: 20px; text-align: center; color: #999; font-size: 13px;">
          <i class="material-icons" style="font-size: 40px; color: #ddd; display: block; margin-bottom: 10px;">inbox</i>
          No unassociated shipping labels found
        </div>
      </div>
    </div>

    <p class="ShippingDetailsContainerBodyTitle">
      {{'GeneralShippingInformation' | translate}}
      <img *ngIf="this.CurrentReception.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + this.CurrentReception.Details.ShippingDetails.ShippingCompany.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
    </p>

    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
      <mat-select name="ShippingServiceType" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingServiceType">
        <mat-option *ngFor="let s of this.ShippingServiceTypes" [value]="s">
          {{s.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-label>{{ 'ShippingWay' | translate }}</mat-label>
      <mat-select name="ShippingWay" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingWay">
        <mat-option *ngFor="let s of this.ShippingWays" [value]="s">
          {{s.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
      <mat-select name="ShippingResponsability" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingResponsability">
        <mat-option *ngFor="let s of this.ShippingResponsabilities" [value]="s">
          {{s.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
      <mat-select name="ShippingCompany" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.ShippingCompany">
        <mat-option *ngFor="let s of this.ShippingCompanies" [value]="s">
          {{s.Name}}
          <img *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-label>{{ 'WeightType' | translate }}</mat-label>
      <mat-select name="WeightType" [compareWith]="compareFn" [(ngModel)]="this.CurrentReception.Details.ShippingDetails.WeightType">
        <mat-option *ngFor="let t of this.WeightTypes" [value]="t">
          {{t.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p class="ShippingDetailsContainerBodyTitle">{{'TransportedBoxesInformation' | translate}}</p>

    <button mat-raised-button color="primary" (click)="AddNewBox();" style="margin-bottom: 10px;">{{'AddNewParcel' | translate}}</button>

    <div class="ParcelContainerHeadder" *ngIf="this.CurrentReception?.Details?.ShippingDetails?.Boxes?.length > 0;">

      <div class="ParcelIndexHeadder">
          <span>#</span>
      </div>

      <div class="ParcelDimentionHeadder">
        <span>{{ 'Length' | translate }}</span>
      </div>

      <i class="material-icons BetweenDimentionsX">close</i>

      <div class="ParcelDimentionHeadder">
        <span>{{ 'Width' | translate }}</span>
      </div>

      <i class="material-icons BetweenDimentionsX">close</i>

      <div class="ParcelDimentionHeadder">
        <span>{{ 'Height' | translate }}</span>
      </div>

      <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

      <div class="ParcelDimentionHeadder">
        <span>{{ 'Weight' | translate }}</span>
      </div>

      <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

      <div class="ParcelDimentionHeadder">
        <span>{{ 'WeightType' | translate }}</span>
      </div>

      <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

      <div class="ParcelDimentionHeadder" style="width: auto; max-width: 220px;">
        <span>{{ 'TrackingLabel' | translate }}</span>
      </div>

    </div>

    <div class="ParcelContainer" *ngFor="let box of this.CurrentReception.Details.ShippingDetails.Boxes; let j=index;" style="border-bottom: solid 1px #ddd;">
      <div class="ParcelIndex">
       <span *ngIf="box.IsPallet != true;">{{'Parcel' | translate}}</span>
       <span *ngIf="box.IsPallet == true;">{{'Pallet' | translate}}</span>
       <span>#{{j + 1}}</span>
      </div>
      
      <mat-form-field appearance="outline" class="ParcelDimention">
        <mat-label>{{ 'Length' | translate }}*</mat-label>
        <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
      </mat-form-field>

      <i class="material-icons BetweenDimentionsX">close</i>

      <mat-form-field appearance="outline" class="ParcelDimention">
        <mat-label>{{ 'Width' | translate }}*</mat-label>
        <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
      </mat-form-field>

      <i class="material-icons BetweenDimentionsX">close</i>

      <mat-form-field appearance="outline" class="ParcelDimention">
        <mat-label>{{ 'Height' | translate }}*</mat-label>
        <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
      </mat-form-field>

      <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

      <mat-form-field appearance="outline" class="ParcelDimention">
        <mat-label>{{this.CurrentInvoice?.Details?.ShippingDetails?.WeightType?.Name}}*</mat-label>
        <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
      </mat-form-field>

      <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

      <mat-checkbox class="PalletCheckBox" [(ngModel)]="box.IsPallet">{{'Pallet' | translate}}?</mat-checkbox>

      <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

      <mat-form-field appearance="outline" class="BoxTrackingLabel">
        <mat-label>{{ 'TrackingLabel' | translate }}</mat-label>
        <input matInput placeholder="{{'TrackingLabel' | translate}}" autocomplete="off" [(ngModel)]="box.TrackingLabel">
      </mat-form-field>

      <div class="boxStatus" *ngIf="box.ID > 0;">
        <i class="material-icons">check</i>
      </div>

      <div class="boxStatus">
        <i class="material-icons" style="color: red;cursor: pointer;" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;">close</i>
      </div>
    </div>

  </div>
  <div class="ShippingDetailsContainerCommands">
    <button *ngIf="this.CurrentReception.Details.ShippingDetails?.ID > 0;" mat-raised-button color="warn" style="float:left;" (click)="ShowDeleteShippingDetailsContainer = true;" matTooltipClass='neutral-tool-tip'>
      <i class="material-icons ">delete_forever</i>
    </button>
    <button mat-raised-button color="primary" style="float:right;" (click)="ShowShippingDetailsContainer = false;" matTooltip="{{ 'NoSavingAtDBLevelWarning' | translate }}" matTooltipClass='neutral-tool-tip'>OK</button>
    <button mat-raised-button color="accent" style="float:right;margin-right: 10px;" (click)="ProofShippingDetails(this.CurrentReception.Details.ShippingDetails, true);" matTooltip="{{ 'SaveToDBDescription' | translate }}" matTooltipClass='neutral-tool-tip'>{{'SaveToDB' | translate}}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowPushConnectedServiceResults">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowPushConnectedServiceResults = false; currentSpending = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'PushConnectedServiceResultsTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'PushConnectedServiceResultsDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowPushConnectedServiceResults = false; ShowConnectedServiceContainer = true;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowPushConnectedServiceResults = false;PushConnectedServiceResults(ConnectedServiceProducts, 'FoxlineAutomotiveReceptionPush', this.CurrentReception);">{{'SendResultsTo' | translate}}: {{ConnectedService.ServiceName}}</button>
  </div>
</div>

<div class="animated fadeInDown ConnectedServiceContainer" *ngIf="ShowConnectedServiceContainer == true;">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowConnectedServiceContainer = false;">close</i>
  </div>

  <div class="InfoQuestionTitle">
    {{ConnectedService.Title}}
   </div>
   <div class="ConnectedServiceDescription">
    {{ConnectedService.Description}}
   </div>

   <div class="ConnectedBodyTopShadow"></div>

   <div class="ConnectedServiceBody">
      <div class="ConnectedServiceProductRow" *ngFor="let product of this.ConnectedServiceProducts">
       <div class="ConnectedServiceProductRowInfoContainer" (click)="SelectConnectedServiceProduct(product);">
        <p class="ConnectedServiceProductTitle"><span style="color: #333;">{{'NameCode' | translate}}:</span> [{{product.Code}}] {{product.Name}}</p>
        <p class="ConnectedServiceProductInfoRow"><span style="color: #333;">{{'Quantity' | translate}}:</span> {{product.Quantity}}</p>
        <p class="ConnectedServiceProductInfoRow"><span style="color: #333;">{{'SuggestedProducts' | translate}}:</span> {{product.SuggestedProducts?.length}}</p>
       </div>
      
        <div class="ConnectedServiceProductRowIcons">
          <i class="material-icons unSelectable" (click)="ReinitializeConnectedServiceProductResults(product, 'FoxlineAutomotive');" style="color: #f60;" matTooltip="{{ 'ReinitializeResults' | translate }}" matTooltipClass='neutral-tool-tip'>refresh</i>
          <i class="material-icons unSelectable" *ngIf="product.IsSelected == true && product.SuggestedProducts?.length;" (click)="SelectConnectedServiceProduct(product);" matTooltip="{{ 'Close' | translate }}" matTooltipClass='neutral-tool-tip'>keyboard_arrow_up</i>
          <i class="material-icons unSelectable" *ngIf="product.IsSelected != true && product.SuggestedProducts?.length;" (click)="SelectConnectedServiceProduct(product);" matTooltip="{{ 'Open' | translate }}" matTooltipClass='neutral-tool-tip'>keyboard_arrow_down</i>
          <i class="material-icons unSelectable" (click)="GetExtraResultProductsFromConnectedService(product, 'FoxlineAutomotive');" style="color: #32aa3a;" matTooltip="{{ 'SearchMoreReceptionConnectedServiceResults' | translate }}" matTooltipClass='neutral-tool-tip'>add</i>
        </div>

        <div *ngIf="product.IsSelected == true;">

          <p class="SuggestedServiceProductUnallocatedQtyTitle" *ngIf="product.SuggestedProducts?.length;">
            {{'UnallocatedQuantity' | translate}}:
            <span style="font-weight: 500;color:#0082e6;">{{product.UnallocatedQuantity}}</span>
          </p>

        <div class="SuggestedServiceProductRow" *ngFor="let sp of product.SuggestedProducts">
          <div class="SuggestedServiceProductRowCheck">
            <mat-checkbox class="SuggestedProductsCheckBox" [(ngModel)]="sp.IsSelected" *ngIf="!sp.Disabled" (change)="ConnectedServiceSuggestionProductSelectionChange(product, sp, 'FoxlineAutomotive')"></mat-checkbox>
            <mat-checkbox [disabled]="true" class="SuggestedProductsCheckBox" [(ngModel)]="sp.IsSelected" *ngIf="sp.Disabled && sp.Status.ID != 4;"></mat-checkbox>
          </div>
           <div class="SuggestedServiceProductRowInfo">
            <p class="ConnectedServiceProductTitle"><span style="color: #333;">{{'BrandAndName' | translate}}:</span> [{{sp.Brand}}] {{sp.Name}}</p>
            <p class="ConnectedServiceProductInfoRow"><span style="color: #333;">{{'Quantity' | translate}}:</span> {{sp.Quantity}}</p>
            <p class="ConnectedServiceProductInfoRow" *ngIf="sp.PartNumber?.length > 0;"><span style="color: #333;">Part-Number:</span> {{sp.PartNumber}}</p>
            <div *ngIf="sp.Status?.ID != 4 && sp.Status?.ID != -1;">
              <p class="ConnectedServiceProductInfoRow" *ngIf="sp.EventRegister?.length > 0;"><span style="color: #333;">{{'EventRegister' | translate}}:</span> {{sp.EventRegister}}</p>
              <p class="ConnectedServiceProductInfoRow" *ngIf="sp.ClientName?.length > 0;"><span style="color: #333;">{{'ClientName' | translate}}:</span> {{sp.ClientName}}</p>
              <p class="ConnectedServiceProductInfoRow" style="color: #f60;" *ngIf="sp.DebatorPO?.length > 0;"><span style="color: #333;">{{'DebatorPO' | translate}}:</span> {{sp.DebatorPO}}</p>
              <button (click)="AddUpdateConnectedServiceSuggestedStockProduct(product, sp,'FoxlineAutomotive');" mat-raised-button color="primary" class="ConnectedServiceProductAddStockButton" *ngIf="product.UnallocatedQuantity > 0;">
                <i class="material-icons">add</i>
                {{'AddStockButton' | translate}}
              </button>
            </div>
            <div *ngIf="sp.Status?.ID == 4">
              <p class="ConnectedServiceProductInfoRow"><span style="color: #333;">{{'ProductID' | translate}}:</span> {{sp.ProductID}}</p>
              <p class="ConnectedServiceProductInfoRow"><span style="color: #333;">{{'Status' | translate}}:</span> {{sp.Status.Name}}</p>
            </div>

            <button (click)="AddUpdateConnectedServiceSuggestedStockProduct(product, sp,'FoxlineAutomotive');" mat-raised-button color="primary" style="background:#32aa3a;" class="ConnectedServiceProductAddStockButton" *ngIf="product.UnallocatedQuantity > 0 && sp.Status?.ID == 4;">
              <i class="material-icons">add</i>
              {{'CompleteStockButton' | translate}}
            </button>

           </div>
           <div class="SuggestedServiceProductRowStatus">
            <p class="ConnectedServiceProductTitle">Status:</p>
            <p class="ConnectedServiceProductInfoRow"><span style="color: #333;">{{sp.Status.Name}}</span></p>
            <i class="material-icons ConnectedServiceProductDeleteButton" (click)="DeleteConnectedServiceSuggestedProduct(product, sp,'FoxlineAutomotive');">close</i>
           </div>
        </div>
       </div>
      </div>
   </div>

   <div class="ConnectedServiceCommands">
    <button (click)="OpenShowPushConnectedServiceResults();" mat-raised-button color="primary" class="ConnectedServiceSendButton">{{'SendResultsTo' | translate}}: {{ConnectedService.ServiceName}}</button>
   </div>

</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOriginalCurrencyError">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowOriginalCurrencyError = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
   {{'ShowOriginalCurrencyError' | translate}}
  </div>
  <div class="InfoQuestionBody">
    {{'ShowOriginalCurrencyErrorDesc' | translate}}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" (click)="ShowOriginalCurrencyError = false;">
      {{ 'OK' | translate }}
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="SingleCurrencyOnCollectivePaymentError">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="SingleCurrencyOnCollectivePaymentError = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
   {{'SingleCurrencyError' | translate}}
  </div>
  <div class="InfoQuestionBody">
    {{'SingleCurrencyErrorDesc' | translate}}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" (click)="SingleCurrencyOnCollectivePaymentError = false;">
      {{ 'OK' | translate }}
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeactivatedDocumentsOnSelectAllQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeactivatedDocumentsOnSelectAllQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
   {{'CanceledDocumentsFound' | translate}}
  </div>
  <div class="InfoQuestionBody">
    {{'CanceledDocumentsFoundDescription' | translate}}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" style="background-color: #f60;" (click)="InitializeNewCollectivePayment();">
      <i class="material-icons">warning_amber</i>
      {{ 'Include' | translate }}
    </button>
    <button [disabled]="this.parent.loading" color="accent" mat-raised-button class="InfoQuestionButton" (click)="DeselectDeactivatedDocs();InitializeNewCollectivePayment();">
      <i class="material-icons">forward</i>
      {{ 'IgnoreCanceledDocuments' | translate }}
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteReceptionRelatedPayments">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteReceptionRelatedPayments = false; SuggestedPayments = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ShowDeleteReceptionRelatedPayments' | translate }} | {{'Payments' | translate}}: [{{this.SuggestedPayments?.length}}]
  </div>
  <div class="InfoQuestionBody">
    {{ 'ShowDeleteReceptionRelatedPaymentsDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteReceptionRelatedPayments = false; SuggestedPayments = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteReceptionRelatedPayments = false;DeletePayments(SuggestedPayments);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeactivateDocumentQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeactivateDocumentQuestion = false; CurrentReception = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'DocumentDeactivationTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'DocumentDeactivationDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false; CurrentReception = null;">{{ 'No' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;CancelReception(CurrentReception);">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowReactivateDocumentQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowReactivateDocumentQuestion = false; CurrentReception = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'DocumentReactivationTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'DocumentReactivationDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false; CurrentReception = null;">{{ 'No' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false;ActivateReception(CurrentReception);">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowAutoPrintBulkQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowAutoPrintBulkQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'AutoPrintBulkTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'AutoPrintBulkDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowAutoPrintBulkQuestion = false;">{{ 'No' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowAutoPrintBulkQuestion = false; AutoPrintReceptions();">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowStockEntryDateTodayQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowStockEntryDateTodayQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'StockEntryDateTodayTitle' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'StockEntryDateTodayDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowStockEntryDateTodayQuestion = false;">{{ 'No' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowStockEntryDateTodayQuestion = false; ModifyReceptionStockEntryDatesToToday();">{{ 'Yes' | translate }}</button>
  </div>
</div>

<div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestionPaymentsContainer" style="left: 16%;width: 83%;">
  <div class="PopUpCloseContainer" (click)="ShowSuggestionPaymentsContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer" style="height: auto;padding-left: 0;padding-right: 0;">
    <p>{{ 'DetectedPayments' | translate }}</p>

    <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;width: 95%;margin-left: 2.5%;margin-top: 15px;">
      <div class="ReceptionProductsCol" style="width: 5%;">
        {{ 'Document' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 15%;">
        {{ 'Supplier' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'PaymentDate' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'Value' | translate }} 
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'PaymentType' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 5%;">
          {{ 'Currency' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 5%;">
          {{ 'Receptions.ExchangeRate' | translate }}
        </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
        {{ 'Receptions.DecimalPercision' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 20%;">
          {{ 'CollectionExternalID' | translate }}
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
          {{ 'Actions' | translate }}
      </div>
    </div>
   </div>

   <div class="PopUpBody" style="margin-top: 5px;">

  <div class="ReceptionProductsContainer  top-box">

      <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
          <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
      </div>

      <div *ngIf="!loading">
          <div class="ReceptionProductsRow" *ngFor="let c of this.SuggestedPayments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1, 'DupplicateCC': c.IsDuplicate == true }">
              <div class="ReceptionProductsCol" style="width: 5%;">
               <span *ngIf="c.Status.ID == 1;">{{c.DisplayValue}}</span>
               <span *ngIf="c.Status.ID == -1;">---</span>
              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
                  <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                  <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{c.PaymentDateUI}}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{c.Value}} 
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                {{c.Type.Name}}
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                  {{c.Currency.Name}}
              </div>
              <div class="ReceptionProductsCol" style="width: 5%;">
                  <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                  <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  {{c.Currency.DecimalPrecision.ID}}
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;">
                  {{c.PaymentExternalID}}
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  <i class="material-icons ReceptionProductEdit" (click)="OpenSuggestedPaymentModifier(c); ShowSuggestedPaymentModifier = true;">edit</i>
                  <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="ClonePayment(c); ShowDeleteSpendingQuestion = true;">close</i>
              </div>
          </div>
      </div>

    
  </div>
  
   </div>

   <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
      <div *ngIf="this.SuggestedPayments != null && this.SuggestedPayments.length > 0 && !loading;">
          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.PaymentTotals; let i=index;">
              <div class="ReceptionProductsCol" style="width: 5%;">
                   
              </div>
              <div class="ReceptionProductsCol" style="width: 15%;">
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                  {{this.SuggestedPayments.length}} {{'Payments' | translate}}
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                  Total:
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                  {{Total.Currency.Name}}
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                  
              </div>
              <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                  
              </div>
              <div class="ReceptionProductsCol" style="width: 20%;">
                
              </div>
              <div class="ReceptionProductsCol" style="width: 10%;">
                  
              </div>
          </div>
      </div>
  </div>
</div>

<div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestedPaymentModifier">
  <div class="PopUpCloseContainer" (click)="ShowSuggestedPaymentModifier = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
    <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
   </div>

   <div class="PopUpBody" style="margin-top: 20px;">
      
      <div class="currentPaymentRadioGroupContainer">
          <mat-radio-group
          [(ngModel)]="currentPayment.Category">
          <mat-radio-button class="example-radio-button" *ngFor="let c of this.PaymentCategories" [value]="c">
            {{c.Name}}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div *ngIf="this.currentPayment.Category.ID == 0;">
          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
              <mat-label>{{ 'AssociatedReception' | translate }}*</mat-label>
              <input *ngIf="!this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchReceptions(this.currentPayment.DisplayValue);" (keyup)="SearchReceptions(this.currentPayment.DisplayValue);">
              <input disabled="disabled" *ngIf="this.currentPayment.ReceptionID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
              <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.ReceptionID.length > 0;" (click)="this.currentPayment.ReceptionID = '';this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
              <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.ReceptionID.length > 0 && SearchedReceptions != null;" (click)="this.currentPayment.DisplayValue = ''; SearchedReceptions = null">close</mat-icon>
          </mat-form-field>

          <div class="InvoiceSearchContainer" *ngIf="SearchedReceptions != null;">
              <div class="InvoiceSearchResult" *ngFor="let r of this.SearchedReceptions; let j=index;" (click)="SelectReceptionForPaymentSearch(r);">
                 <div class="InvoiceSearchResultCol">
                  {{r.AccountingNumber.DisplayValue}}
                 </div>
                 <div class="InvoiceSearchResultCol" style="width: 40%;">
                  {{r.Supplier.Name}}
                 </div>
                 <div class="InvoiceSearchResultCol">
                  {{r.EventRegisterUIDate}}
                 </div>
                 <div class="InvoiceSearchResultCol">
                  {{r.Total.TotalQtyPriceVAT}} {{r.Currency.Name}}
                 </div>
              </div>
          </div>
      </div>

      <div *ngIf="this.currentPayment.Category.ID == 1;">
          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
              <mat-label>{{ 'AssociatedSpending' | translate }}*</mat-label>
              <input *ngIf="this.currentPayment.SpendingID == null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchSpendings(this.currentPayment.DisplayValue);" (keyup)="SearchSpendings(this.currentPayment.DisplayValue);">
              <input disabled="disabled" *ngIf="this.currentPayment.SpendingID != null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
              <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.SpendingID != null;" (click)="this.currentPayment.SpendingID = null;this.currentPayment.DisplayValue = '';this.currentPayment.ReceptionDetailsID = null">close</mat-icon>
              <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.SpendingID != null && Spendings != null;" (click)="this.currentPayment.DisplayValue = '';this.currentPayment.SpendingID = null;">close</mat-icon>
          </mat-form-field>

          <div class="InvoiceSearchContainer" *ngIf="Spendings != null;">
              <div class="InvoiceSearchResult" *ngFor="let s of this.Spendings; let j=index;" (click)="SelectSpendingForPaymentSearch(s);">
                 <div class="InvoiceSearchResultCol" style="width: 60%;">
                  {{s.Partner.Name}}
                 </div>
                 <div class="InvoiceSearchResultCol">
                  {{s.DocumentDateUI}}
                 </div>
                 <div class="InvoiceSearchResultCol">
                  {{s.Total.TotalQtyPriceVAT}} {{s.Currency.Name}}
                 </div>
              </div>
          </div>
      </div>

      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'PaymentType' | translate }}</mat-label>
          <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
            <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
              {{type.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'Currency' | translate }}</mat-label>
          <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
            <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
              {{c.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
          <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
            <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
              {{b.DisplayValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
          <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
          <mat-icon matSuffix>calculate</mat-icon>
        </mat-form-field>

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
          <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
            <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
              {{d.Meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

    <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
      <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
      <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
      <mat-datepicker #dp3></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
      <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
      <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value" (change)="VerifyPriceModel(this.currentPayment.Value);">
      <mat-icon matSuffix>monetization_on</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
      <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
      <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
      <mat-icon matSuffix>qr_code_2</mat-icon>
    </mat-form-field>
   </div>

   <div class="PopUpCommands">
    <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="ShowSuggestedPaymentModifier = false;">
        <span>{{'UpdatePayment' | translate}}</span>
  </button>
  </div>
</div>

<div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowPaymentContainer">
  <div class="PopUpCloseContainer" (click)="ShowPaymentContainer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
    <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
   </div>

   <div class="PopUpBody" style="margin-top: 20px;">

      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'PaymentType' | translate }}</mat-label>
          <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
            <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
              {{type.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'Currency' | translate }}</mat-label>
          <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
            <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
              {{c.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
          <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
            <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
              {{b.DisplayValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
          <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
          <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
          <mat-icon matSuffix>calculate</mat-icon>
        </mat-form-field>

        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
          <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
            <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
              {{d.Meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

    <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
      <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
      <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
      <mat-datepicker #dp3></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
      <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
      <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value" style="color: #32aa3a;" (change)="VerifyPriceModel(this.currentPayment.Value);">
      <mat-icon matSuffix>monetization_on</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
      <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
      <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
      <mat-icon matSuffix>qr_code_2</mat-icon>
    </mat-form-field>

      <p class="CashCollectRemainingInfo" *ngIf="this.PaymentRemainingValue >= 0;">{{'RemainingToPay' | translate}}: {{this.PaymentRemainingValue}} {{this.currentPayment.Currency.Name}}</p>
      <p class="CashCollectRemainingInfo" *ngIf="this.PaymentRemainingValue < 0;">{{'OverPayed' | translate}}: {{this.PaymentRemainingValue}} {{this.currentPayment.Currency.Name}}</p>
   </div>

   <div class="PopUpCommands" *ngIf="this.IsCollectivePayment == false;">
      <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddPayment();ShowPaymentContainer = false;">
        <span>{{'AddPayment' | translate}}</span>
      </button>
  </div>
  <div class="PopUpCommands" *ngIf="this.IsCollectivePayment == true;">
    <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddGroupPayment();ShowPaymentContainer = false;">
      <span>{{'AddPayment' | translate}}</span>
    </button>
</div>
</div>

<div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
    <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="PopUpTitleContainer">
     <p>{{ 'Partners.EditPartner' | translate }}</p>
    </div>

    <div class="PopUpBody">

      <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>

      <form [formGroup]="currentPartner">
        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
          <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
          <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
          <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
        </mat-form-field>

        <div class="PopUpBodySemiTextBox">
          <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
        </div>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
            <mat-select name="country" [compareWith]="compareFn" formControlName="Country" required>
              <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
        </mat-form-field>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>

        <div class="PopUpBodySemiTextBox">
          <mat-form-field>
            <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
            <mat-select name="bank" [compareWith]="compareFn" formControlName="Bank">
              <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                {{b.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
        </mat-form-field>

        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Login.Email' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
        </mat-form-field>

        <mat-form-field class="example-full-width PopUpBodySemiTextBox">
          <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
          <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
        </mat-form-field>
      </form>

    </div>

    <div class="PopUpCommands">
      <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="UpdatePartner();">Update Partner</button>
    </div>
</div>

<div class="animated fadeInDown DocumentContainer" *ngIf="showReceptionVisualizer">
  <div class="PopUpCloseContainer" (click)="showReceptionVisualizer = false;">
    <i class="material-icons">close</i>
  </div>

  <div class="PopUpTitleContainer">
    <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID == null && !DocumentBodyLoading;">
      <span *ngIf="!IsStorno;">{{ 'Receptions.NewReception' | translate }}</span>
      <span *ngIf="IsStorno;">{{ 'Receptions.StornoReception' | translate }}</span>
      </p>
      <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentReception.ID != null && !DocumentBodyLoading;">
        <span>
          {{CurrentReception.AccountingNumber.AccountingSeries.Series}} 
          {{(CurrentReception.AccountingNumber.Number)}} 
          / {{CurrentReception.EventRegisterUI}}
        </span>
      </p>
   </div> 

   <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button color="primary" class="VizualizeCommandButton" (click)="ExportReception(CurrentReception);">
      <i class="material-icons">file_copy</i>
      <span>{{ 'Receptions.Document.Export' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" (click)="PrintReception(CurrentReception);">
      <i class="material-icons">print</i>
      <span>{{ 'Receptions.Document.Print' | translate }}</span>
    </button>

    <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" [matMenuTriggerFor]="menuReception">
      <i class="material-icons">settings</i>
      <span>{{ 'Receptions.Document.Actions' | translate }}</span>
    </button>   
    
    <mat-menu #menuReception="matMenu">
      <button mat-menu-item (click)="ViewReception(CurrentReception);" class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID != -1;">
          <i class="material-icons">mode_edit</i>
          <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
      </button>
      
      <button mat-menu-item class="ReceptionMenuButton" (click)="DownloadFile(CurrentReception);" *ngIf="CurrentReception.FilePath != null;">
        <i class="material-icons">file_download</i>
        <span>{{ 'DownloadFile' | translate }}</span>
      </button>

      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID != -1;" (click)="PrepareETransportStep1();">
        <i class="material-icons">qr_code_2</i>
        <span>{{ 'ETransportGeneration' | translate }}</span>
      </button>

      <button mat-menu-item class="ReceptionMenuButton" (click)="GenerateStorno(CurrentReception);" *ngIf="CurrentReception.DocumentStatus.ID != -1 && CurrentReception.IsStorno != true;">
          <i class="material-icons">settings_backup_restore</i>
          <span>{{ 'Receptions.Table.ButtonMenu.stornate' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID != -1;" (click)="this.ShowDeactivateDocumentQuestion = true;">
          <i class="material-icons">close</i>
          <span>{{ 'Receptions.Table.ButtonMenu.cancelDoc' | translate }}</span>
      </button>
      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID == -1;" (click)="this.ShowReactivateDocumentQuestion = true;">
          <i class="material-icons">verified</i>
          <span>{{ 'Receptions.Table.ButtonMenu.reactivateDoc' | translate }}</span>
      </button>

      <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentReception.DocumentStatus.ID != -1;" (click)="GetConnectedServicePushLog(CurrentReception, 'FoxlineAutomotive');">
        <i class="material-icons">cast_connected</i>
        <span>{{ 'SendReceptionToAutomotive' | translate }}</span>
      </button>

      <button mat-menu-item class="ReceptionMenuButton" (click)="DeleteReception(CurrentReception);">
          <i class="material-icons">delete_forever</i>
          <span>{{ 'Receptions.Table.ButtonMenu.delete' | translate }}</span>
      </button>
     </mat-menu>

     <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(CurrentReception);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
      <i class="material-icons">print</i>
      <span>{{ 'AutoPrint' | translate }}</span>
    </button>

    <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
  </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="!CurrentReception.IsStorno">
     <div class="DocumentBody">

      <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

       <div style="border: solid 1px #333;">
        
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.Title' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">
          <tbody>
            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.UndersignedTitle' | translate }} {{this.CurrentReception.Supplier.Name}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.SupplyingDocuments' | translate }}: {{this.CurrentReception.DocumentNumber}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Delegate' | translate }}: {{this.CurrentReception.Details.Delegate}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Observations' | translate }}: {{this.CurrentReception.Details.Observations}}
                  </td>
                </tr>
              </tbody>
            </table>
            
            <table style="width: 100%;margin-top: 5px;margin-bottom: 20px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.Auto' | translate }}: {{this.CurrentReception.Details.Auto}}
                  </td>
                </tr>
              </tbody>
            </table>

          </tbody>
        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Received' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.Price.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'VATPercentages' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                           <span *ngFor="let vat of CurrentReception.VATs">{{vat?.Percentage}}%; </span>
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.Details.SigningAgent?.Name}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>

       </div>

     </div>
   </div>

   <div class="PopUpBody" style="max-height: 75vh;" *ngIf="CurrentReception.IsStorno">
    <div class="DocumentBody">

     <p class="DocumentBodyCanceled" *ngIf="CurrentReception.DocumentStatus.ID == -1;">anulata</p>

      <div style="border: solid 1px #333;">
        <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
          <tbody>
            <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
              <td>{{ 'Receptions.Document.DocumentStorno.ReturnTitle' | translate }}</td>
            </tr>

            <table style="width: 100%;margin-top: 25px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                  <td>{{ 'Receptions.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.DocNr' | translate }}:  {{CurrentReception.AccountingNumber.AccountingSeries.Series}}{{(CurrentReception.AccountingNumber.Number)}}</td>
                </tr>
              </tbody>
            </table>

            <table style="width: 100%;margin-top: 5px;">
              <tbody>
                <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                  <td>{{ 'Receptions.Document.Administrations' | translate }}: 
                    <span *ngFor="let a of this.CurrentReception.Administrations; let i=index;">{{a.Name}}; </span>
                  </td>
                </tr>
                <tr style="width: 30%;text-align: left;float: left;">
                  <td>{{ 'Receptions.Document.Date' | translate }}: {{CurrentReception.EventRegisterUI}}</td>
                </tr>
              </tbody>
            </table>
           
          </tbody>
        </table>

        <table style="width: 100%;border-bottom: solid 1px #333;">

          <tbody>
            <table style="width: 100%;margin-top: 5px;margin-bottom: 25px;">
              <tbody>
                <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                  <td>
                    {{ 'Receptions.Document.DocumentStorno.ReturnSubTitle' | translate }} {{this.CurrentReception.Supplier.Name}} 
                    {{ 'Receptions.Document.DocumentStorno.OnDocumentBasis' | translate }} {{CurrentReception.DocumentNumber}} / {{CurrentReception.DocumentDate}}
                  </td>
                </tr>
              </tbody>
            </table>
          </tbody>

        </table>

        <table style="width: 100%;">
          <tbody>
            
            <table style="width: 100%;font-size: 12px;">
              <tbody>
                <tr style="width: 100%;">

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>
                      <tr>
                        <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.Nr' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'Receptions.Document.Table.Name' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'Receptions.Document.Table.MU' | translate }}</td>
                        <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'Receptions.Document.Table.DocQuantity' | translate }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </td>

                  <td style="width: 50%;float: left;padding: 0;">
                    <table style="width: 100%;">
                    <tbody>

                      <tr>
                      <td style="padding: 0;">
                        <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                          <tbody>
                            <tr>
                              <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'Receptions.Document.Table.Returned' | translate }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      </tr>

                      <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;padding: 0;">
                            <tbody>
                              <tr>
                                <td style="text-align: center;width: 15%;padding: 0;">{{ 'Receptions.Document.Table.Quantity' | translate }}</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.UnitPrice' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 30%;padding: 0;">{{ 'Receptions.Document.Table.TotalValue' | translate }} ({{CurrentReception.Currency.Name}})</td>
                                <td style="text-align: center;width: 25%;padding: 0;">{{ 'Receptions.Document.Table.VATValue' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                  </td>

                </tr>

                <tr style="width: 100%;">

                 <td style="padding: 0;">
                  <table style="width: 100%;">
                    <tbody>
                      <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentReception.Products; let i=index;">
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{i + 1}}
                        </td>
            
                        <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          ({{p.ProductReceptionInfo.Code}}) {{p.ProductReceptionInfo.Name}}
                        </td>
            
                        <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.MeasuringUnit.Name}}
                        </td>
            
                        <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.DocQuantity}}
                        </td>
            
                        <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Quantity}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIUnitPrice}}
                        </td>
            
                        <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                          {{p.ProductReceptionInfo.Price.UIQtyPrice}}
                        </td>
            
                        <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{p.ProductReceptionInfo.TotalVATValue}}
                        </td>
                      </tr>
                    </tbody>
                    </table>
                 </td>

                </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.TotalNOVAT' | translate }}:
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.Table.VATValue' | translate }}:
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                          {{ 'Receptions.Document.Table.Total' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                           
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceNOVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                          {{CurrentReception.Total.TotalVAT}} {{CurrentReception.Currency.Name}}
                         </td>
             
                         <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                          {{CurrentReception.Total.TotalQtyPriceVAT}} {{CurrentReception.Currency.Name}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                          {{ 'Receptions.Document.ReceptionCommitee' | translate }}: {{CurrentReception.Details.ReceptionCommittee}}
                         </td>
             
                         <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.ReceivedInAdministration' | translate }}:
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
             
                         <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{ 'Receptions.Document.FullName' | translate }}:
                         </td>
             
                         <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Signature' | translate }}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                           
                         </td>
             
                         <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                          {{CurrentReception.Details.SigningAgent?.Name}}
                         </td>
                        
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

                 <tr style="width: 100%;border-top: solid 1px #333;">

                  <td style="padding: 0;">
                   <table style="width: 100%;">
                     <tbody>
                       <tr style="width: 100%;height: 20px;line-height: 20px;">
                         <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                          {{ 'Receptions.Document.Currency' | translate }}: {{CurrentReception.Details.CurrencyRow}}
                         </td>
                       </tr>
                     </tbody>
                     </table>
                  </td>
 
                 </tr>

              </tbody>
            </table>

          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.DeleteQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentPayment = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false;DeletePayment(currentPayment.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteReceptionQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowDeleteReceptionQuestion = false; CurrentReception = null;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'Configuration.DeleteQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'Configuration.DeleteQuestionDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteReceptionQuestion = false; CurrentReception = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteReceptionQuestion = false;DeleteReception(CurrentReception);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
  </div>
</div>

<div class="MainTitleBar" style="overflow: hidden;" *ngIf="Periods != null;">
  <div class="MainTitleBarIconContainer">
    <i class="material-icons">date_range</i>
  </div>

  <div class="FifteenPercentContainer">
    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
      <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
      <mat-select name="Administration" [(ngModel)]="Filter.Period">
        <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetReceptionsFiltered();">
          {{a.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="MainTitleBarIconContainer">
    <i class="material-icons">date_range</i>
  </div>

  <div class="FifteenPercentContainer">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
      <mat-datepicker #dp></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="MainTitleBarIconContainer">
    <i class="material-icons">date_range</i>
  </div>

  <div class="FifteenPercentContainer">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
      <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
      <mat-datepicker #dp1></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="FifteenPercentContainer" style="margin-top: -4px;">
      <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetReceptionsFiltered();">
        <mat-icon>filter_alt</mat-icon>
      </button>
  </div>

</div>

<div class="MainTitleBar" style="overflow: unset;" *ngIf="Periods != null;">
  <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
    <i class="material-icons">filter_alt</i>
    <span>{{'Filter' | translate}}</span>
</div>

    <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowAutoPrintBulkQuestion = true;">
      <i class="material-icons">print</i>
    </div>

    <div class="FilterButton noselect IntrastatBtn" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="GenerateIntrastatArrivalXML();" matTooltip="{{ 'IntrastatArrivalsTooltip' | translate }}" matTooltipClass="neutral-tool-tip">
      <i class="material-icons">insert_drive_file</i>
    </div>

    <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowExportBulkQuestion = true;">
      <i class="material-icons">file_copy</i>
    </div>

    <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowStockEntryDateTodayQuestion = true;">
      <i class="material-icons">today</i>
      <span>{{'StockEntryDateToday' | translate}}</span>
    </div>

    <div class="ActiveFiltersContainer">
      <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
        {{a.Name}}
        <i class="material-icons">close</i>
      </div>
    </div>

    <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
        <div class="FilterCloseContainer" (click)="this.showFilter = false;">
            <i class="material-icons">close</i>
        </div>

        <div class="FilterContainerBody">

            <div class="PopUpBodyRow">
              
            </div>

            <div class="PopUpBodyOneThirddContainer">
                <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                    <mat-select name="Administration" [(ngModel)]="Filter.Administration">
                      <mat-option *ngFor="let a of this.Administrations;" [value]="a" (click)="AddActiveFilter(a.Name, 'Administration');">
                        {{a.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            
            <div class="PopUpBodyOneThirddContainer">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'Receptions.Series' | translate }}</mat-label>
               <mat-select name="Series" [(ngModel)]="Filter.AccountingSeries">
                <mat-option *ngFor="let a of this.AccountingSeries;" [value]="a" (click)="AddActiveFilter(a.Series, 'Series');">
                   {{a.Series}}
                 </mat-option>
               </mat-select>
              </mat-form-field>
            </div>
             
            <div class="PopUpBodyOneThirddContainer">
                <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>Doc.Status</mat-label>
                    <mat-select name="Series" [(ngModel)]="Filter.DocumentStatus">
                      <mat-option *ngFor="let d of this.DocumentStatuses;" [value]="d" (click)="AddActiveFilter(d.Name, 'DocStatus');">
                        {{d.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            <div class="PopUpBodyOneThirddContainer">
                <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                    <mat-label>{{ 'Receptions.DocNumber' | translate }}*</mat-label>
                    <input matInput placeholder="Doc Number*" autocomplete="off" [(ngModel)]="Filter.DocumentNumber" (change)="AddActiveFilter('Doc: ' + Filter.DocumentNumber, 'DocumentNumber');">
                  </mat-form-field>
            </div>
            
            <div class="PopUpBodyTwoThirdsContainer">
                <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                    <mat-label>{{ 'SearchProductInvoicesFilter' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'SearchProductInvoicesFilter' | translate }}" autocomplete="off" [(ngModel)]="Filter.Product" (change)="AddActiveFilter('PN: ' + Filter.Product, 'Product');">
                  </mat-form-field>
            </div>

            <div class="PopUpBodyTwoThirdsContainer">
                <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                    <mat-label>{{ 'Receptions.SearchSupplier' | translate }}*</mat-label>
                    <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm = Partners[0].Name;this.Filter.Partner = Partners[0];AddActiveFilter(Partners[0].Name, 'Partner');GetReceptionsFiltered();">
                    <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                    <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                  </mat-form-field>

                  <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                    <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm=p.Name;this.Filter.Partner = p;AddActiveFilter(p.Name, 'Partner');">
                        <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                    </div>
                  </div>
            </div>

            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                  <mat-label>{{'Currency' | translate}}</mat-label>
                  <mat-select name="Currency" [(ngModel)]="Filter.Currency">
                    <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Currency');">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
            </div>

            <div class="PopUpBodyTwoThirdsContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{'PaymentApprovalStatus' | translate}}</mat-label>
                <mat-select name="ReceivedStatus" [(ngModel)]="Filter.ReceivedStatus">
                  <mat-option *ngFor="let s of this.ReceivedStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ReceivedStatus');">
                    {{s.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{'TranzactionType' | translate}}</mat-label>
                <mat-select name="TranzactionType" [(ngModel)]="Filter.TranzactionType">
                  <mat-option [value]="null" (click)="RemoveActiveFilter('TranzactionType');">
                    {{ 'All' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let t of this.TranzactionTypes;" [value]="t" (click)="AddActiveFilter(t.Name, 'TranzactionType');">
                    {{t.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

        </div>
        
        <div class="FilterCommands">
            <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetReceptionsFiltered();">{{ 'Receptions.FilterButton' | translate }}</button>
        </div>
    </div>

    <div class="TotalDocCountContainer">
      <span style="float: right;">{{this.Receptions?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'ReceptionsWord' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
      <div class="PageSizeContainer">
        <mat-form-field appearance="outline" class="PageSizeTextBox">
          <mat-label>{{ 'PageSize' | translate }}*</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetReceptionsFiltered(1);">
        </mat-form-field>
      </div>
    </div>

    <div class="TotalDocCountContainer">
      <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetReceptionsFiltered(this.Filter.Pager.PageIndex - 1);">
        <i class="material-icons">chevron_left</i>
      </div>
      <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
        <i class="material-icons">chevron_left</i>
      </div>

      <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetReceptionsFiltered(this.Filter.Pager.PageIndex + 1);">
        <i class="material-icons">chevron_right</i>
      </div>
      <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
        <i class="material-icons">chevron_right</i>
      </div>
    </div>
</div>

<div class="MainBody">

    <div class="ReceptionProductsContainer">
      
        <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
            <div class="ReceptionProductsCol" style="width: 2.5%;">
              <mat-checkbox class="tableColCheckBox" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
                {{ 'Receptions.Table.Nr' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 13%;text-align: left;cursor: pointer;" (click)="JuggleSorting();">
              {{ 'Supplier' | translate }}
              <i class="material-icons tableHeadderSortingIcon" *ngIf="this.Filter.SortingOrder?.ID == 1;">keyboard_arrow_down</i>
              <i class="material-icons tableHeadderSortingIcon" *ngIf="this.Filter.SortingOrder?.ID == 2;">keyboard_arrow_up</i>
            </div>
            <div class="ReceptionProductsCol" style="width: 11.5%;text-align: left;padding-left: 1%;">
              {{ 'ReceptionJustifyingDocument' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{ 'StockEntryDate' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{ 'DueDate' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7%;">
              {{ 'SubTotal' | translate }} <span *ngIf="Filter.ExchangeToTargetCurrency">({{currency?.Name}})</span>
            </div>
            <div class="ReceptionProductsCol" style="width: 7%;">
              {{ 'VATTotal' | translate }} <span *ngIf="Filter.ExchangeToTargetCurrency">({{currency?.Name}})</span>
            </div>
            <div class="ReceptionProductsCol" style="width: 9%;">
                Total <span *ngIf="Filter.ExchangeToTargetCurrency">({{currency?.Name}})</span>
            </div>
            <div class="ReceptionProductsCol" style="width: 5%;" [style.cursor]="AnyChecked ? 'pointer' : 'default'" (click)="LoadPOProductInfoBulk();" matTooltip="Match selected receptions with PO data" matTooltipClass='neutral-tool-tip'>
              PO
              <i class="material-icons" style="font-size: 14px;vertical-align: middle;" *ngIf="!loadingPOMatch && AnyChecked">sync</i>
              <span *ngIf="loadingPOMatch" style="font-size: 10px;color: #f60;">{{loadingPOMatchIndex}}/{{loadingPOMatchTotal}}</span>
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{ 'Status' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{ 'PaymentApproval' | translate }}
            </div>
            <div class="ReceptionProductsCol" style="width: 7.5%;">
              {{ 'Actions' | translate }}
            </div>
        </div>

        <div class="ReceptionProductsRow TotalRow" *ngIf="this.loading == true;">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>
        <div *ngIf="!loading">
            <div [ngClass]="{'deactivatedReception': r.DocumentStatus.ID == -1}" class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let r of this.Receptions; let i=index;">
                <div class="ReceptionProductsCol" style="width: 2.5%;">
                  <mat-checkbox class="tableColCheckBox" [(ngModel)]="r.IsSelected" (change)="CheckIfAnyChecked();"></mat-checkbox>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <p class="ReceptionTitleP">
                      <span (click)="VizualizeDocument(r);" class="ReceptionTitleSpan">{{r.AccountingNumber.DisplayValue}}</span>
                    </p>
                    <p *ngIf="r.IsStorno && loadingInvoiceID != r.ID;" class="stornoRow">storno</p>
                    <mat-progress-bar mode="buffer" *ngIf="loadingDocumentInformation && loadingReceptionID == r.ID;" class="loadingDocumentInformation"></mat-progress-bar>
                </div>
                <div class="ReceptionProductsCol SupplierNameCol" style="width: 13%;text-align: left;">
                    <p>{{r.Supplier.Name}}</p>
                    <i class="material-icons OverduePaymentDaysAlert" *ngIf="r.OverduePaymentDays > 0 && r.DocumentStatus.ID == 5;" matTooltip="{{r.OverduePaymentDays}} {{'DaysLate' | translate}}" matTooltipClass='neutral-tool-tip'>watch_later</i>
                </div>
                <div class="ReceptionProductsCol" style="width: 11.5%;text-align: left;padding-left: 1%;">
                    <p>{{r.DocumentNumber}}</p>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{r.EventRegisterUI}}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{r.PaymentDueDateUI}}
                </div>
                <div class="ReceptionProductsCol" style="width: 7%;">
                    <p>{{r.Total.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{r.Total.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                </div>
                <div class="ReceptionProductsCol" style="width: 7%;">
                    <p>{{r.Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{r.Total.UITotalVAT.Decimals}}</span></p>
                </div>
                <div class="ReceptionProductsCol" style="width: 9%;">
                    <p><span>{{r.Total.UITotalQtyPriceVAT.Integer}}</span> <span class="DecimalsSpan">{{r.Total.UITotalQtyPriceVAT.Decimals}}</span> <span class="ReceptionIndividualCurrencyRow" *ngIf="Filter.ExchangeToTargetCurrency == false;">{{r.Currency.Name}}</span></p>
                    <div class="CashCollectionsRemainingValues" *ngIf="r.Details.PaymentRemainingValue != r.Total?.TotalQtyPriceVAT && r.Details.PaymentRemainingValue > 0;">
                      {{'RemainingPayment' | translate}}: {{r.Details.PaymentRemainingValue}} {{r.InitialSavedCurrency?.Name}}
                    </div>
                  </div>
                <div class="ReceptionProductsCol" style="width: 5%;padding-top: 12px;">
                    <div class="po-status-bar-container" *ngIf="r.POProductInfo">
                      <div class="po-status-bar po-bar-green" [style.width.%]="r.POProductInfo.ExpectedPricePercent" matTooltip="Expected: {{r.POProductInfo.ExpectedPricePercent | number:'1.0-0'}}%" matTooltipClass='neutral-tool-tip'></div>
                      <div class="po-status-bar po-bar-orange" [style.width.%]="r.POProductInfo.PriceNotFoundPercent" matTooltip="Not Found: {{r.POProductInfo.PriceNotFoundPercent | number:'1.0-0'}}%" matTooltipClass='neutral-tool-tip'></div>
                      <div class="po-status-bar po-bar-red" [style.width.%]="r.POProductInfo.PriceDifferencePercent" matTooltip="Price Diff: {{r.POProductInfo.PriceDifferencePercent | number:'1.0-0'}}%" matTooltipClass='neutral-tool-tip'></div>
                      <div class="po-status-bar po-bar-purple" [style.width.%]="r.POProductInfo.QuantityExceededPercent" matTooltip="Qty Exceeded: {{r.POProductInfo.QuantityExceededPercent | number:'1.0-0'}}%" matTooltipClass='neutral-tool-tip'></div>
                    </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  <p>
                    <span [ngClass]="{'CancelledStatus': r.Status.ID == -1, 'CollectedStatus': r.Status.ID == 1,'PartiallyCollected': r.Status.ID == 2,'SurplusCollected': r.Status.ID == 3, 'CreatedStatus': r.Status.ID == 4, 'Overdue': r.Status.ID == 5}">{{r.Status.Name}}</span>
                  </p>
                  <div *ngIf="r.DocumentStatus.ID == 5;" class="OverDueDaysNote">
                    {{r.OverduePaymentDays}} {{'DaysLate' | translate}}
                  </div>
                  <div *ngIf="r.Details.ForceDocumentClosing == true;" class="OverDueDaysNote">
                    {{'ForcedDocumentClose' | translate}}
                  </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  <div class="received-status-toggle-container" matTooltip="{{r.Details.ReceivedStatus.Name}}" matTooltipClass='neutral-tool-tip' (click)="OpenWorkingClaim(r);">
                    <label class="received-status-toggle" [ngClass]="{'received-status-blocked': r.Details.ReceivedStatus.ID == -1}">
                      <input type="checkbox" [(ngModel)]="r.Details.ReceivedStatus.Received" (change)="ChangeReceivedStatus(r);" [disabled]="r.Details.ReceivedStatus.ID == -1">
                      <span class="received-toggle-slider"></span>
                    </label>
                  </div>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    <i class="material-icons actionsArrow" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
                       <mat-menu #menu="matMenu">
                        <button mat-menu-item class="ReceptionMenuButton" (click)="VizualizeDocument(r);">
                            <i class="material-icons">image_search</i>
                            <span>{{ 'Receptions.Table.ButtonMenu.Visualize' | translate }}</span>
                        </button>
                        <button mat-menu-item (click)="ViewReception(r);" class="ReceptionMenuButton" *ngIf="r.DocumentStatus.ID != -1;">
                          <i class="material-icons">mode_edit</i>
                          <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" (click)="DownloadFile(r);" *ngIf="r.FilePath != null;">
                          <i class="material-icons">cloud_download</i>
                          <span>{{ 'DownloadFile' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" (click)="GetReceptionPayments(r.Details.ID);">
                          <i class="material-icons">playlist_add_check</i>
                          <span>{{ 'Payments' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="r.IsSelected" (click)="AlertDeactivatedDocumentsOnSelectAll(r);">
                          <i class="material-icons">euro</i>
                          <span>{{ 'NewPayment' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="!r.IsSelected" (click)="InitializeNewPayment(r);">
                          <i class="material-icons">euro</i>
                          <span>{{ 'NewPayment' | translate }}</span>
                        </button>

                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="r.DocumentStatus.ID != -1 && r.Details.ForceDocumentClosing != true;" (click)="ShowForceStatusContainer = true;this.CurrentReception = r;">
                          <i class="material-icons">incomplete_circle</i>
                          <span>{{ 'ForceDocumentClosing' | translate }}</span>
                        </button>

                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="r.DocumentStatus.ID != -1 && r.Details.ForceDocumentClosing == true;" (click)="ShowForceStatusContainer = true;this.CurrentReception = r;">
                          <i class="material-icons">incomplete_circle</i>
                          <span>{{ 'DeForceDocumentClosing' | translate }}</span>
                        </button>

                        <button mat-menu-item class="ReceptionMenuButton" (click)="GenerateStorno(r);" *ngIf="r.DocumentStatus.ID != -1 && r.IsStorno != true;">
                            <i class="material-icons">settings_backup_restore</i>
                            <span>{{ 'Receptions.Table.ButtonMenu.stornate' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="r.DocumentStatus.ID != -1;" (click)="ShowDeactivateDocumentQuestion = true; CurrentReception = r;">
                            <i class="material-icons">close</i>
                            <span>{{ 'Receptions.Table.ButtonMenu.cancelDoc' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="r.DocumentStatus.ID == -1;" (click)="ShowReactivateDocumentQuestion = true; CurrentReception = r;">
                            <i class="material-icons">verified</i>
                            <span>{{ 'Receptions.Table.ButtonMenu.reactivateDoc' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="r.DocumentStatus.ID != -1;" (click)="OpenNewClaimForDocument(r);">
                            <i class="material-icons" style="color: #fd4f57;">report_problem</i>
                            <span>{{ 'OpenNewClaim' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" (click)="ShowDeleteReceptionQuestion = true; this.CurrentReception = r;">
                            <i class="material-icons">delete_forever</i>
                            <span>{{ 'Receptions.Table.ButtonMenu.delete' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" (click)="initializePartnerFormFromObject(r.Supplier);">
                            <i class="material-icons">person_search</i>
                            <span>{{ 'Receptions.Table.ButtonMenu.viewSupplier' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" *ngIf="r.DocumentStatus.ID != -1;" (click)="GeneratePurchaseContractFromReception(r);">
                          <i class="material-icons">view_comfortable</i>
                          <span>{{ 'GeneratePurchaseContract' | translate }}</span>
                        </button>
                        <button mat-menu-item class="ReceptionMenuButton" (click)="this.CurrentReception = r;GetShippingDetails(this.CurrentReception.Details.ID, this.CurrentReception.Supplier.ID);">
                          <i class="material-icons">local_shipping</i>
                          <span>{{ 'ShippingDetails' | translate }}</span>
                        </button>
                       </mat-menu>
                </div>
      </div>
        </div>

        <div *ngIf="!loading && Receptions?.length > 0;">
          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.Totals; let i=index;">
            <div class="ReceptionProductsCol" style="width: 42.5%;text-align: left;padding-left: 1%;">
              <mat-slide-toggle [disabled]="Filter.DisplayAllPagesTotals == true" (change)="GetReceptionsFiltered();" *ngIf="i == 0;" [(ngModel)]="Filter.ExchangeToTargetCurrency">{{'DisplaySingleCurrency' | translate}}</mat-slide-toggle>
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                Total:
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                <p>{{Total.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceNOVAT.Decimals}}</span></p>
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                <p>{{Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalVAT.Decimals}}</span></p>
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                {{Total.Currency.Name}}
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                
            </div>
        </div>
        </div>

        <div *ngIf="!loading && Receptions?.length > 0;">
          <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.Totals; let i=index;">
            <div class="ReceptionProductsCol" style="width: 42.5%;text-align: left;padding-left: 1%;">
              <mat-slide-toggle (change)="GetReceptionsFiltered();" [(ngModel)]="Filter.DisplayAllPagesTotals">{{'DisplayAllPagesTotals' | translate}}</mat-slide-toggle>
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                
            </div>
            <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                
            </div>
            <div class="ReceptionProductsCol" style="width: 10%;">
                
            </div>
        </div>
        </div>

    <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="!loading && Receptions?.length > 0;">
      <div class="ReceptionProductsCol" style="width: 10%;">

      </div>
      <div class="ReceptionProductsCol" style="width: 20%;">
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetReceptionsFiltered(this.Filter.Pager.PageIndex - 1);">
          <i class="material-icons">chevron_left</i>
        </button>

        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
          <i class="material-icons">chevron_left</i>
        </button>
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
        {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetReceptionsFiltered(this.Filter.Pager.PageIndex + 1);">
          <i class="material-icons">chevron_right</i>
        </button>

        <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
          <i class="material-icons">chevron_right</i>
        </button>
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
          
      </div>
      <div class="ReceptionProductsCol totalCol" style="width: 10%;">
          
      </div>
      <div class="ReceptionProductsCol" style="width: 10%;">
          
      </div>
  </div>

    </div>

</div>
</div>

<!-- Intrastat Arrivals Progress Dialog -->
<div class="IntrastatProgressOverlay" *ngIf="ShowIntrastatProgress">
  <div class="IntrastatProgressCard">
    <mat-progress-bar mode="determinate" [value]="IntrastatProgressPercent || 0"></mat-progress-bar>
    <div class="IntrastatProgressPercent">{{ IntrastatProgressPercent || 0 }}%</div>
    <div class="IntrastatProgressStatus">{{ IntrastatProgressMessage || 'Processing...' }}</div>
    <div class="IntrastatProgressDetail">{{ IntrastatDetailMessage }}</div>
  </div>
</div>

<!-- Intrastat Arrivals Validation Dialog -->
<div class="IntrastatValidationOverlay" *ngIf="ShowIntrastatValidation">
  <div class="IntrastatValidationCard">
    <div class="IntrastatValidationHeader">
      <h3>{{ 'IntrastatArrivalsGenerated' | translate }}</h3>
      <button mat-icon-button (click)="CloseIntrastatValidation()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="IntrastatValidationContent">
      <div class="IntrastatDeclarationItem" *ngFor="let declaration of IntrastatDeclarations">
        <div class="IntrastatDeclarationInfo">
          <strong>{{ declaration.RefMonth | number: '2.0-0' }}/{{ declaration.RefYear }}</strong>
          <span>{{ declaration.ReceptionCount }} {{ 'ReceptionsWord' | translate }} | {{ declaration.ArrivalItemCount }} {{ 'ItemsWord' | translate }}</span>
        </div>
        <button mat-raised-button color="primary" (click)="DownloadIntrastatArrivalXML(declaration)">
          <mat-icon>download</mat-icon>
          {{ 'Download' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
